export const WritingReportAnimation = ({ id = '' }: { id?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="1138"
      height="640"
      viewBox="0 0 1138 640"
      className="text-primary mx-auto h-16 w-full"
      id={id}
    >
      <defs>
        <filter id="card-shadow" x="-50%" y="-50%" width="200%" height="200%" colorInterpolationFilters="sRGB">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#000000" floodOpacity="0.06" />
          <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#000000" floodOpacity="0.10" />
        </filter>
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_4_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="1"
          keyTimes="0;1"
          values="1;1"
          keySplines="0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_4_G"
          fill="freeze"
          keyTimes="0;0.9;1"
          path="M569 320 C569,320 569,320 569,320 C569,320 569,164 569,164 "
          keyPoints="0;0;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_4_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.5;0.5000004;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.9;0.95;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          keyTimes="0;0.4;0.5;0.9;0.9958333;1"
          path="M569 320 C569,320 569,320 569,320 C569,320 569,164 569,164 C569,164 569,164 569,164 C569,164 569,4 569,4 C569,4 569,4 569,4 "
          keyPoints="0;0;0.49;0.49;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.4;0.45;1"
          values="1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          keyTimes="0;0.4;0.4958333;1"
          path="M569 164 C569,164 569,164 569,164 C569,164 569,4 569,4 C569,4 569,4 569,4 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.5;0.5;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="1"
          keyTimes="0;0.3958333;0.4;0.4916667;0.4958333;0.8958333;0.9;0.9916667;0.9958333;1"
          values="1;1;0;0;1;1;0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G"
          fill="freeze"
          keyTimes="0;0.4;0.5;0.9;0.9958333;1"
          path="M569 320 C569,320 1139,320 1139,320 C1139,320 569,320 569,320 C569,320 1139,320 1139,320 C1139,320 569,320 569,320 C569,320 569,320 569,320 "
          keyPoints="0;0.25;0.5;0.75;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          keyTimes="0;0.4;0.5;0.9;1"
          path="M423.15 291 C423.15,291 994,291 994,291 C994,291 423,291 423,291 C423,291 994,291 994,291 C994,291 423,291 423,291 "
          keyPoints="0;0.25;0.5;0.75;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="3 3"
          to="3 3"
          type="scale"
          additive="sum"
          keyTimes="0;0.4;0.4083333;0.5;0.9;0.9083333;1"
          values="3 3;3 3;2.5 2.5;3 3;3 3;2.5 2.5;3 3"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-60 -60"
          to="-60 -60"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-60 -60;-60 -60"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="10s" from="0" to="1" xlinkHref="#time_group" />
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_4_G_M">
          <g id="_R_G_L_4_G">
            <path id="_R_G_L_4_G_D_0_P_0" fill="#000000" fillOpacity="1" fillRule="nonzero" d=" M-285 104 C-285,104 284,104 284,104 " />
            <path
              id="_R_G_L_4_G_D_1_P_0"
              stroke="#f4f4f4"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="80"
              strokeOpacity="1"
              d=" M-285 104 C-285,104 284,104 284,104 "
            />
          </g>
        </g>
        <g id="_R_G_L_3_G">
          <path id="_R_G_L_3_G_D_0_P_0" fill="#000000" fillOpacity="1" fillRule="nonzero" d=" M-285 104 C-285,104 284,104 284,104 " />
          <path
            id="_R_G_L_3_G_D_1_P_0"
            stroke="#f4f4f4"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            strokeWidth="80"
            strokeOpacity="1"
            d=" M-285 104 C-285,104 284,104 284,104 "
          />
        </g>
        <g id="_R_G_L_2_G_M">
          <g id="_R_G_L_2_G">
            <path id="_R_G_L_2_G_D_0_P_0" fill="#000000" fillOpacity="1" fillRule="nonzero" d=" M-285 104 C-285,104 284,104 284,104 " />
            <path
              id="_R_G_L_2_G_D_1_P_0"
              stroke="#f4f4f4"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="80"
              strokeOpacity="1"
              d=" M-285 104 C-285,104 284,104 284,104 "
            />
          </g>
        </g>
        <g id="_R_G_L_1_G">
          <path
            id="_R_G_L_1_G_D_0_P_0"
            fill="#ffffff"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M323.36 54.22 C323.36,54.22 323.36,158.11 323.36,158.11 C323.36,158.11 -285.22,158.11 -285.22,158.11 C-285.22,158.11 -285.22,54.22 -285.22,54.22 C-285.22,54.22 323.36,54.22 323.36,54.22z "
          />
          <path
            id="_R_G_L_1_G_D_1_P_0"
            fill="#f4f4f4"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-282.17 63.66 C-304.15,63.66 -321.97,81.48 -321.97,103.46 C-321.97,125.45 -304.15,143.27 -282.17,143.27 C-260.18,143.27 -242.36,125.45 -242.36,103.46 C-242.36,81.48 -260.18,63.66 -282.17,63.66z "
          />
        </g>
        <g id="pencil-shadow" filter="url(#card-shadow)">
          <g id="_R_G_L_0_G">
            <path
              id="_R_G_L_0_G_D_0_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M106.06 25.58 C106.06,25.93 106.05,26.28 106.02,26.63 C105.79,29.48 104.6,32.16 102.64,34.23 C102.64,34.23 51.6,88.44 51.6,88.44 C51.01,89.06 50.21,89.46 49.36,89.55 C48.83,89.6 48.3,89.54 47.8,89.36 C47.3,89.18 46.85,88.89 46.47,88.51 C46.47,88.51 46.32,88.36 46.32,88.36 C46.32,88.36 38.54,80.59 38.54,80.59 C38.54,80.59 30.54,72.58 30.54,72.58 C30.05,72.1 29.72,71.49 29.57,70.82 C29.44,70.22 29.46,69.59 29.65,69 C29.83,68.41 30.16,67.88 30.61,67.45 C30.61,67.45 84.82,16.41 84.82,16.41 C87.2,14.16 90.37,12.93 93.65,12.98 C96.93,13.03 100.06,14.36 102.37,16.68 C102.37,16.68 102.49,16.79 102.49,16.79 C104.79,19.14 106.07,22.3 106.06,25.58z "
            />
            <path
              id="_R_G_L_0_G_D_1_P_0"
              fill="#757575"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M46.32 88.37 C46.32,88.37 38.95,92.87 38.95,92.87 C38.95,92.87 38.93,92.88 38.93,92.88 C38.93,92.88 26.28,80.23 26.28,80.23 C26.28,80.23 26.35,80.12 26.35,80.12 C26.35,80.12 30.8,72.84 30.8,72.84 C30.8,72.84 38.54,80.59 38.54,80.59 C38.54,80.59 46.32,88.37 46.32,88.37z "
            />
            <path
              id="_R_G_L_0_G_D_2_P_0"
              fill="#757575"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M46.32 88.37 C46.32,88.37 38.95,92.87 38.95,92.87 C38.95,92.87 38.93,92.88 38.93,92.88 C38.93,92.88 26.28,80.23 26.28,80.23 C26.28,80.23 26.35,80.12 26.35,80.12 C26.35,80.12 30.8,72.84 30.8,72.84 C30.8,72.84 38.54,80.59 38.54,80.59 C38.54,80.59 46.32,88.37 46.32,88.37z "
            />
            <path
              id="_R_G_L_0_G_D_3_P_0"
              fill="#e7c14d"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M39.5 103.34 C31.47,104.07 23.46,104.8 15.45,105.52 C14.75,105.59 14.06,105.65 13.37,105.71 C13.43,105 13.5,104.29 13.56,103.58 C14.28,95.57 14.99,87.56 15.7,79.55 C19.26,79.74 22.81,79.93 26.35,80.12 C26.35,80.12 26.4,80.12 26.4,80.12 C26.4,80.12 32.7,86.42 32.7,86.42 C32.7,86.42 38.93,92.65 38.93,92.65 C38.93,92.65 38.95,92.86 38.95,92.86 C38.95,92.86 39.5,103.34 39.5,103.34z "
            />
            <path
              id="_R_G_L_0_G_D_4_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M25.44 95.54 C25.44,95.54 15.45,105.52 15.45,105.52 C14.75,105.59 14.06,105.65 13.37,105.71 C13.43,105 13.5,104.29 13.56,103.58 C13.56,103.58 23.51,93.61 23.51,93.61 C23.51,93.61 23.98,94.08 23.98,94.08 C23.99,94.1 24.01,94.12 24.03,94.14 C24.03,94.14 24.5,94.6 24.5,94.6 C24.5,94.6 25.06,95.16 25.06,95.16 C25.06,95.16 25.44,95.54 25.44,95.54z "
            />
            <path
              id="_R_G_L_0_G_D_5_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M25.06 95.16 C25.06,95.16 24.03,94.14 24.03,94.14 C23.57,93.67 23.3,93.04 23.3,92.38 C23.3,91.71 23.57,91.08 24.03,90.61 C24.5,90.15 25.13,89.88 25.8,89.88 C26.46,89.88 27.09,90.15 27.56,90.61 C27.56,90.61 28.58,91.64 28.58,91.64 C28.82,91.87 29,92.15 29.13,92.45 C29.25,92.75 29.32,93.08 29.32,93.4 C29.32,93.73 29.25,94.05 29.13,94.36 C29,94.66 28.82,94.93 28.58,95.16 C28.35,95.4 28.08,95.58 27.78,95.71 C27.47,95.83 27.15,95.9 26.82,95.9 C26.5,95.9 26.17,95.83 25.87,95.71 C25.57,95.58 25.29,95.4 25.06,95.16z "
            />
            <path
              id="_R_G_L_0_G_D_6_P_0"
              fill="#000000"
              fillOpacity="0.24"
              fillRule="nonzero"
              d=" M102.32 16.6 C102.32,16.6 38.52,80.54 38.52,80.54 C38.52,80.54 32.69,86.38 32.69,86.38 C32.69,86.38 32.58,86.5 32.58,86.5 C32.58,86.5 28.03,91.06 28.03,91.06 C28.03,91.06 24.51,94.59 24.51,94.59 C24.51,94.59 13.4,105.72 13.4,105.72 C14.11,105.66 14.82,105.59 15.53,105.53 C23.54,104.81 31.55,104.09 39.56,103.38 C39.37,99.83 39.18,96.28 38.99,92.73 C38.99,92.73 46.27,88.29 46.27,88.29 C46.27,88.29 46.53,88.55 46.53,88.55 C47.01,89.04 47.62,89.37 48.29,89.52 C48.89,89.65 49.52,89.62 50.11,89.44 C50.7,89.26 51.24,88.93 51.66,88.48 C51.66,88.48 102.7,34.27 102.7,34.27 C104.95,31.89 106.18,28.72 106.13,25.44 C106.08,22.16 104.75,19.03 102.43,16.71 C102.43,16.71 102.32,16.6 102.32,16.6z "
            />
          </g>
        </g>
      </g>
      <g id="time_group" />
    </svg>
  )
}
